<template>
    <div class="box_input agreement_item" style="padding: 24px 20px">
        <div class="agreement_item_header">
            <strong class="tit">{{$t('EnrolmentAgreementItemEditor_agreementNo', {number: agreementNo})}}</strong>
            <!--            <CommonCheckbox v-model="mandatory" class="checkbox" :key="'check'+ agreementNo">-->
            <!--                <template #labelText>필수 동의로 설정</template>-->
            <!--            </CommonCheckbox>-->
            <button
                v-show="isShowDelete"
                type="button"
                class="btn_input sm del"
                @click.prevent="deleteAgreement"
            >{{$t('EnrolmentAgreementItemEditor_delete')}}
            </button>
        </div>

        <div class="info_txt full">
            <div class="bx_input_wrap">
                <TextArea
                    ref="input_title"
                    :id="inputTitleId"
                    :placeholder="$t('EnrolmentAgreementItemEditor_inputAgreementTitle')"
                    :maxlength="100"
                    v-model="question"
                    cols="50"
                    rows="1"
                    label-class="input_lbl"
                    label-tag="label"
                    :one-line="true"
                    @keydown.native="focusNextAgreement"
                />
            </div>
        </div>
        <div class="info_txt desc_txt full">
            <div class="bx_input_wrap">
                    <TextArea
                        ref="input_desc"
                        :id="inputDescId"
                        :placeholder="$t('EnrolmentAgreementItemEditor_inputAgreementDesc')"
                        :maxlength="1000"
                        v-model="questionDesc"
                        cols="50"
                        rows="3"
                        label-class="input_lbl"
                        label-tag="label"
                        @keydown.native="focusNextAgreement"
                    />
            </div>
        </div>
    </div>
</template>

<script>
import {DELETE_AGREEMENT} from '@common/store/modules/enrolment/editor.js';
import {mapActions} from 'vuex';
import TextArea from '@iamteacherpc/components/common/TextArea.vue';
import {requestConfirm} from '@iamteacherpc/utils/iframe';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@common/store/modules/common/editor/questionList';
import CommonCheckbox from '@iamteacherpc/assets/common/component/CommonCheckbox.vue';
import IconCheckSquare from '@iamteacherpc/assets/common/icon/IconCheckSquare.vue';
import IconCheckSquareEmpty from '@iamteacherpc/assets/common/icon/IconCheckSquareEmpty.vue';

export default {
    name: 'EnrolmentAgreementItemEditor',
    components: {
        IconCheckSquareEmpty,
        IconCheckSquare,
        CommonCheckbox,
        TextArea,
    },

    props: {
        agreementIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        agreements() {
            return this.$store.getters['enrolment/getField'](`form.agreements`);
        },

        isShowDelete() {
            return this.agreements.length > 1;
        },

        agreementNo() {
            return this.agreementIndex + 1;
        },

        inputTitleId() {
            return `agreement-title-${this.agreementIndex}`;
        },
        inputDescId() {
            return `agreement-desc-${this.agreementIndex}`;
        },

        // 항상 필수값으로 스펙 변경되어 버튼 주석처리. 이후에 선택가능하도록 변경될 가능성 있음
        mandatory: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.getStorePath()}.mandatory`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.getStorePath()}.mandatory`,
                    value: newValue,
                });
            },
        },
        question: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.getStorePath()}.question`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.getStorePath()}.question`,
                    value: newValue,
                });
            },
        },
        questionDesc: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.getStorePath()}.questionDesc`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.getStorePath()}.questionDesc`,
                    value: newValue,
                });
            },
        },
    },

    methods: {
        ...mapActions('enrolment', {
            storeDeleteAgreement: DELETE_AGREEMENT,
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
        }),

        getStorePath() {
            return `form.agreements[${this.agreementIndex}]`;
        },

        async deleteAgreement() {
            try {
                await this.stopListChange();

                await requestConfirm({
                    title: this.$t('EnrolmentAgreementItemEditor_confirmDelete'),
                });

                await this.storeDeleteAgreement({
                    agreementIndex: this.agreementIndex,
                });
            } catch (e) {
                if (e) {
                    throw e;
                }
            } finally {
                await this.listChange();
            }
        },

        focusAgreement() {
            this.$refs.input_title.focus();
        },

        focusNextAgreement(event) {
            // if (event.keyCode !== 13) {
            //     return;
            // }
            // this.$emit('focusNextAgreement');
        },
    },
};
</script>

<style scoped lang="scss">
.agreement_item:first-child {
    margin-top: 0;
}

.info_txt {
    &.desc_txt {
        margin-top: 10px;
        margin-left: 0 !important;
    }
}
</style>
